export default __webpack_public_path__ + "static/media/local_attractionlocal_play.c25eb9f0.svg";